import { Rating } from "@mui/material";
export const RatingStars = ({ value }) => {
  return (
    <>
      <Rating
        value={Number(value) || 0}
        precision={0.5}
        size="small"
        readOnly
        sx={{ fontSize: 14 }}
      />
      <span>({(Number(value) || 0).toFixed(2)})</span>
    </>
  );
};
